import React from 'react';
const chips = ['No forms to fill', 'Refunded to your original payment method', 'Keep the bonuses'];
export function Guarantee() {
  return <section aria-labelledby="guarantee-heading" className="sage-ground w-full" data-id="element-107" data-mp="1o5q1qgnuw7zz">
      <div className="mx-auto max-w-3xl px-5 py-16 text-center sm:py-20" data-id="element-108" data-mp="222wiy6sxlyn3">
        <div className="mx-auto flex h-24 w-24 flex-col items-center justify-center rounded-full border-[3px] border-ochre text-ochre" data-id="element-109" data-mp="1x5d4b5sbnjum">
          <span className="font-display text-4xl leading-none" data-id="element-110" data-mp="19f0qjeaeasw4">7</span>
          <span className="text-[11px] font-bold uppercase tracking-widest" data-id="element-111" data-mp="14gz54mphyhhh">
            Days
          </span>
        </div>
        <p className="mt-6 text-[11px] font-bold uppercase tracking-[1.6px] text-ochre" data-id="element-112" data-mp="1j5vcehjqbqh1">
          Zero risk
        </p>
        <h2 id="guarantee-heading" className="chalk-underline on-dark mt-3 font-display text-[28px] text-cream sm:text-5xl" data-id="element-113" data-mp="1ec0spe44jbhy">
          Open everything. Offer one card in session.
        </h2>
        <p className="mx-auto mt-5 max-w-2xl text-base text-cream/75" data-id="element-114" data-mp="ozrsamz5l05m">
          Read the volumes, print the card deck, try one experiment with a
          client. If Gestalt Session Ready doesn&apos;t change how you prepare
          and offer experiments, email us within 7 days and get every cent
          back.
        </p>
        <ul className="mt-7 flex flex-wrap justify-center gap-2.5" data-id="element-115" data-mp="12pv8oxbcpzn5">
          {chips.map(chip => <li key={chip} className="rounded-full border border-sage-line px-4 py-2 text-[13px] text-cream/80" data-id="element-116" data-mp="61yx66urtuis">
              {chip}
            </li>)}
        </ul>
      </div>
    </section>;
}